<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="formData">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info" />
          {{ dataId ? '查看' : '新增' }}机型价格
        </div>
        <div class="fr">
          <!--          <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置-->
          <!--          </el-button>-->
          <el-button type="primary"
            v-if="(basItemPriceAdd && formData.id == null) || (basItemPriceEdit && formData.id != null)"
            class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
        </div>
      </div>
      <div>
        <!-- 品牌信息 -->
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <b>主信息</b>
            </div>
            <table class="table-detail">
              <tbody>
                <tr>
                  <th>
                    <em class="f-red">*</em>
                    产品编码
                  </th>
                  <td>
                    <el-input type="text" autocomplete="off" v-model="formData.itemCode" clearable readonly="true">
                      <i slot="suffix" class="el-input__icon el-icon-search" @click="showPreconditionDialog = true"></i>
                    </el-input>
                  </td>
                  <th>
                    <em class="f-red">*</em>
                    产品名称
                  </th>
                  <td>
                    <el-input type="text" autocomplete="off" v-model="formData.itemName" clearable readonly="true"
                      disabled>
                      <!-- <i slot="suffix" class="el-input__icon el-icon-search" @click="showPreconditionDialog=true"></i> -->
                    </el-input>
                  </td>
                  <th>
                    <em class="f-red">*</em>
                    销售价格
                  </th>
                  <td>
                    <el-input type="number" autocomplete="off" min="0" v-model="formData.price" clearable />
                  </td>


                </tr>
                <tr>
                  <th>
                    <em class="f-red">*</em>日期
                  </th>
                  <td colspan="3">
                    <el-date-picker class="current-date-picker" v-model="formData.date" type="daterange" align="right"
                      unlink-panels style="width: 100%;" range-separator="-" start-placeholder="开始日期"
                      end-placeholder="结束日期" value-format='yyyy-MM-dd HH:mm:ss'>
                    </el-date-picker>
                  </td>
                  <!-- <th>
                    <em class="f-red">*</em>
                    开始日期
                  </th>
                  <td>
                    <el-date-picker type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                      v-model="formData.beginDate" clearable />
                  </td>
                  <th>
                    <em class="f-red">*</em>
                    结束时间
                  </th>
                  <td>
                    <el-date-picker type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                      v-model="formData.endDate" clearable />
                  </td> -->
                </tr>

                <tr>
                  <th>创建人</th>
                  <td>{{ formData.createBy }}</td>
                  <th>创建时间</th>
                  <td>{{ formData.createTime }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </el-form>
    <preconditionDialog v-if="showPreconditionDialog" @commitSelectedRow="commitSelectedRow"
      :visiable.sync="showPreconditionDialog" multi="true" />

  </div>
</template>
<script>

import Area from '@/components/area'
import Tinymce from '@/components/Tinymce';
import request from "@/router/axios";
import api from "@/api/projectApi";
import preconditionDialog from '@/views/dialogCommon/chanPinDialog.vue';

import store from "@/store";
import { mapGetters } from 'vuex';

export default {
  inject: ['reload'],
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  components: {
    Tinymce, Area, preconditionDialog,
  },
  watch: {
    areaName(newVal) {
      console.log('sakdfjksadfj', newVal)
    }
  },
  data() {
    return {
      showPreconditionDialog: false,

      able1: true,
      able2: true,
      able3: true,
      isEdit: false,
      dataId: 0,
      // getDataUrl: '/basic/sfSettleCoefficient/getById',
      // saveDataUrl: '/basic/sfSettleCoefficient/saveOrUpdate',
      areaName: [],
      areaLevel: 4,
      formData: {
        itemId: null,
        itemCode: '',  // 产品编号
        itemName: '',  // 产品名称
        price: null,
        beginDate: '',  // 开始日期
        endDate: '', //结束时间
      },
      rules: {
        itemId: [
          { required: true, prop: '产品不能为空', message: '产品不能为空', trigger: 'blur' }
        ],

        price: [
          { required: true, prop: '销售价格', message: '销售价格不能为空', trigger: 'blur' }
        ],

        beginDate: [
          { required: true, prop: '开始时间', message: '开始时间不能为空', trigger: 'blur' }
        ],

        endDate: [
          { required: true, prop: '结束时间', message: '结束时间不能为空', trigger: 'blur' }
        ],

      },
      tenant: {
        timeType: 1,
        beginDate: '',
        endDate: '',
        usable: 1,
        tenantAttachmentDTOs: []
      },
    };
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  created() {
    if (this._dataId && !isNaN(this._dataId)) {
      this.dataId = this._dataId;
    }
    this.basItemPriceAdd = this.permissions["basItemPriceAdd"];
    this.basItemPriceEdit = this.permissions["basItemPriceEdit"];
  },
  mounted() {
    this.getData();
  },
  methods: {
    commitSelectedRow(data) {
      console.log(data, "选择的data");
      this.formData.itemCode = data.itemCode
      this.formData.itemId = data.id
      this.formData.itemName = data.itemName
    },
    selectChanged(value) {
      this.$forceUpdate();
      console.log(value, "点击的值value");
      if (value == 1) {
        this.able1 = false
        this.formData.starLevel = "";
        this.formData.satisfactionLevel = "";
        this.able2 = true
        this.able3 = true
        // delete formData.starLevel.value;
        // delete formData.satisfactionLevel.value;
        // this.clear()
        // {
        // this.$set(this.formData.starLevel,'value','');
        // this.$set(this.formData.satisfactionLevel,'value','');
        // }
      } else if (value == 2) {
        this.able2 = false
        this.formData.settleLevel = "";
        this.formData.satisfactionLevel = "";
        this.able1 = true
        this.able3 = true
        // delete formData.settleLevel.value;
        // delete formData.satisfactionLevel.vlaue;
        // this.$set(this.formData.settleLevel,'value','')
        // this.$set(this.formData.satisfactionLevel,'value','')
      } else if (value == 3) {
        this.able3 = false
        this.formData.settleLevel = "";
        this.formData.starLevel = "";
        this.able1 = true
        this.able2 = true
        // delete formData.settleLevel.value;
        // delete formData.starLevel.value;
        // this.$set(this.formData.settleLevel,'value','')
        // this.$set(this.formData.starLevel,'value','')
      }
    },
    areaNameChangeHandler(val) {
      console.log('handler', val)
      this.formData.areaId = val
    },

    areaObjChangeHandler(val) {
      this.formData.province = val.province !== undefined ? val.province : ''
      this.formData.city = val.city !== undefined ? val.city : ''
      this.formData.county = val.county !== undefined ? val.county : ''
      this.formData.town = val.town !== undefined ? val.town : ''
    },


    //
    //   handleChange(value) {
    //   console.log(value);
    // },
    // submitForm(formName) {
    //   this.$refs[formName].validate((valid) => {
    //     if (valid) {
    //       alert('submit!');
    //     } else {
    //       console.log('error submit!!');
    //       return false;
    //     }
    //   });
    // },
    // resetForm(formName) {
    //   this.$refs[formName].resetFields();
    // },
    //
    // submitUpload() {
    //   this.$refs.upload.submit()
    // },
    createAreaNamePath() {
      let temp = ''
      if (this.formData.province != null && this.formData.province != '' && this.formData.province != undefined) {
        temp += this.formData.province
        if (this.formData.city != null && this.formData.city != '' && this.formData.city != undefined) {
          temp = temp + '/' + this.formData.city
          if (this.formData.county != null && this.formData.county != '' && this.formData.county != undefined) {
            temp = temp + '/' + this.formData.county
          }
        }
        this.$refs.area.areaNamePath = temp
      }
    },

    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: api.basItemPrice.getDataUrl + "/" + this.dataId,
          method: 'get',
          // data: {
          //   id: this.dataId
          // },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.formData = response.data.data
          //时间回显处理 将data 返回的时间push进去
          let tmpArr = []
          tmpArr.push(this.formData.beginDate)
          tmpArr.push(this.formData.endDate)
          console.log('转成啥', tmpArr)
          this.formData.date = tmpArr
          this.createAreaNamePath()
        })
      }
    },
    saveData() {
      console.log(this.formData.date, "formData.date的值");
      if (this.formData.date && this.formData.date.length >= 2) {
        this.formData.beginDate = this.formData.date[0]
        this.formData.endDate = this.formData.date[1]
        console.log(this.formData.beginDate, this.formData.endDate, '55555');
      }

      this.$validate(this.formData, this.rules).then(() => {
        this.$baseConfirm('您确定要保存吗？').then(() => {
            this.$mask.open()

            var url = (this.isEdit ? api.basItemPrice.updateDataUrl : api.basItemPrice.addDataUrl);
            var method = (this.isEdit ? 'put' : 'post');
            this.$http({
              url: url,
              method: method,
              data: this.formData,
              isLoading: true
            }).then(() => {
              this.$message.success("保存成功！");
              this.reload()
              // this.$emit('editViewDataUpdate')
              this.$mask.close()
            }).catch(e => {
              console.error(e)
              this.$message.error("保存失败！");
              this.$mask.close()

            })
          })
      })

    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 40px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

::v-deep .el-range-editor--medium.el-input__inner {
  height: 32px !important;
}
</style>
